import { useState } from "react";

type ShowHandler = (ms: number) => void;
type Output = readonly [isShow: boolean, showHandler: ShowHandler];
type UseSimpleFeedback = () => Output;

/**
 * @description
 * 簡易的にユーザにフィードバックをする際の要素の表示 ->非表示制御用 hook
 */
export const useSimpleFeedback: UseSimpleFeedback = () => {
  const [isShown, setIsShown] = useState(false);

  const showSimpleFeedback: ShowHandler = (ms) => {
    setIsShown(true);

    const timer = setTimeout(() => {
      setIsShown(false);
      clearTimeout(timer);
    }, ms);
  };

  return [isShown, showSimpleFeedback] as const;
};
